/* ========================== */  
/* ========= import ========= */  
/* ========================== */  

/* ====== React ====== */
// import React from "react"
/* ====== CSS ====== */
import styled from 'styled-components';
/* ====== Component Js/Jsx ====== */
import { assets } from '03CommonApiParts/Configuration';
import { InputErrorMessage } from '02CommonUiParts/TableParts/InputErrorMessage';
/* ========================== */  
/* ========= Styles ========= */  
/* ========================== */  

/* ====== Styled Components ====== */
/* ------　インプットフィールド ------*/
const Sinput = styled.input`//インプット
    height:30px;
    width:125px;
    padding: 0 0 0 5px;
    color: black;
    border-radius:3px;
    border: ${ props => props.readOnly ? 'none' : `solid 1px ${assets().color.border}`};
    appearance: ${props => props.readOnly ? 'none': '' };
    font: inherit;
    background-color:${props => props.readOnly ? 'transparent' : props.isDirty ? assets().color.lightYellow : 'white'};
    cursor: pointer;
    &:disabled{
        opacity:1;
        cursor: default;
        background-color:${props => props.readOnly ? 'transparent' : assets().color.disabled  };
    };
    &:read-only{
        background-color:transparent;
        pointer-events:none;
        border: none;
    };
    &:read-only ::-webkit-calendar-picker-indicator {
        display: none;
    };
    
    
`;
const SinputSearch = styled.input`//検索用インプット
    padding: 0px 5px;
    margin: 2px 0;
    width:${props=>props.width};
    border: solid 1px ${assets().color.border};
    border-radius:3px;
    &:focus{
        outline: solid 1.5px #007BC3;
    };
    &:hover {
        cursor: pointer;
    };
`;
const SlabelSelectTitle = styled.label`//インプットタイトルラベル
    margin-right: 6px;
`;
const Slabel = styled.label`//検索用インプットラベル
    position: absolute;
    left: 0px;
    margin: 3px 0;
    color: ${assets().color.gray};
    pointer-events: none;
    background-color: white;
    padding:0 3px;
    transform: scale(0.8, 0.8);
`;
const SinputBox = styled.div`//インプット小枠
    position: relative;
    border-radius: 3px;
    display: flex;
    align-items: center;
    & ${Sinput}:focus{
        outline: solid 1.5px ${assets().color.focusOutline};
    };
`;

/* ========================== */  
/* ========== Main ========== */  
/* ========================== */ 
export const InputTimeField = (props) => {
    /* ========================== */  
    /* ========== variables ========== */  
    /* ========================== */  
    const { id, errorMessage, value, defaultValue, label, maxLength, pattern, onChange, type, register, disabled, readOnly, boxStyle, isDirty} = props;
    /* ========================== */  
    /* ====== Start Render ====== */  
    /* ========================== */  
    return (
        <>
            <SinputBox style={boxStyle}>
                {label ?
                    <SlabelSelectTitle className='baseText' style={{fontSize:assets().size.baseText}}>{label} :</SlabelSelectTitle>
                :''}
                <Sinput
                    disabled={disabled}
                    readOnly={readOnly}
                    id={id}
                    name={id}
                    max={type === 'date' ? '9999-12-31':'9999-12-31T23:59'}
                    isDirty={isDirty}
                    defaultValue={defaultValue}
                    value={value}
                    maxLength={maxLength}
                    pattern={pattern}
                    onChange={onChange}
                    type={type}
                    placeholder=' '
                    autoComplete='off'
                    {...register}
                    className='inputText' 
                    style={{fontSize:assets().size.baseText,height:assets().size.inputHeight}}
                />
                {errorMessage ? <InputErrorMessage errorMessage={errorMessage}/> :'' }
            </SinputBox>
        </>
    );
};

export const InputSearchTimeField = (props) => {
    /* ========================== */  
    /* ========== variables ========== */  
    /* ========================== */  
        const { style, defaultValue, label, register, error, disabled,width,placeholder, maxLength,type } = props;
        /* ========================== */  
        /* ====== Start Render ====== */  
        /* ========================== */  
      
        return (
            <>
                <SinputBox style={style}>
                    <SinputSearch
                        // id={id}
                        // name={id}
                        maxLength={maxLength}
                        defaultValue={defaultValue}
                        style={{fontSize:assets().size.baseText,height:Number(assets().size.inputHeight.replace('px','')) - 2}} //ここはサイズ変更すると合わなくなるから調整したい🌟
                        width={width}
                        max={type === 'date' ? '9999-12-31':'9999-12-31T23:59'}
                        type={type}
                        placeholder={placeholder}
                        autoComplete='off'
                        {...register}
                        disabled={disabled}
                        className='inputText'
                    />
                    <Slabel className='inputlabelText' style ={{fontSize:assets().size.inputlabelText,top:assets().size.inputlabelTop}}>{label}</Slabel>
                </SinputBox>
                {error ? <InputErrorMessage errorMessage={error}/> : ''}
            </>
            
        );
    };

/*------　日付選択の使い方　------*/
// {/* <InputTimeField
//     id={datetimeField}
//     register={register('payload.datetime')} //react-hook-form
//     payload={payload} //react-hook-form
//     error={error} //react-hook-form
//     defaultValue='2022-07-20T10:10'
//     // require={true}
//     disabled=false //変更可否
//     readOnly=false //見た目をラベルのように変更
//     type='datetime-local' //datetime-local(日時),date(日付)
// /> */}